import { Link } from 'react-router-dom';
import { Package } from 'lucide-react';
import { useTranslation } from '@/contexts/LanguageContext';

export default function Footer() {
  const { t, tc } = useTranslation('footer');

  const footerLinks = {
    destockpro: [
      { label: t('home'), href: '/' },
      { label: tc('howItWorks'), href: '/comment-ca-marche' },
      { label: t('publishAd'), href: '/publier' },
      { label: 'Blog', href: '/blog' },
      { label: tc('signup'), href: '/inscription' },
    ],
    professionals: [
      { label: t('createAccount'), href: '/inscription' },
      { label: t('sellEquipment'), href: '/publier' },
      { label: t('buyEquipment'), href: '/annonces' },
      { label: t('turnkeyService'), href: '/service-publication' },
      { label: tc('faq'), href: '/faq' },
    ],
    informations: [
      { label: tc('about'), href: '/a-propos' },
      { label: tc('contact'), href: '/contact' },
      { label: tc('terms'), href: '/conditions-utilisation' },
      { label: tc('privacy'), href: '/politique-confidentialite' },
    ],
  };

  return (
    <footer className="bg-[#1F3F72] text-white" data-testid="footer">
      <div className="site-container py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 rounded-md bg-white/20 flex items-center justify-center">
                <Package className="w-5 h-5 text-white" />
              </div>
              <span className="font-heading text-xl font-bold">DestockPro</span>
            </Link>
            <p className="text-sm text-blue-200 leading-relaxed">
              {tc('slogan')}
            </p>
            <div className="mt-6 text-xs text-blue-300 space-y-1">
              <Link to="/contact" className="hover:text-white transition-colors">{t('contactUs')}</Link>
            </div>
          </div>

          {/* Links columns */}
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">DestockPro</h4>
            <ul className="space-y-2.5">
              {footerLinks.destockpro.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-blue-200 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">{t('professionals')}</h4>
            <ul className="space-y-2.5">
              {footerLinks.professionals.map((link) => (
                <li key={link.label}>
                  <Link to={link.href} className="text-sm text-blue-200 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-white">{t('information')}</h4>
            <ul className="space-y-2.5">
              {footerLinks.informations.map((link) => (
                <li key={link.href}>
                  <Link to={link.href} className="text-sm text-blue-200 hover:text-white transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-blue-300">&copy; {new Date().getFullYear()} DestockPro - {t('allRightsReserved')}</p>
          <p className="text-xs text-blue-300">www.destockpro.be</p>
        </div>
      </div>
    </footer>
  );
}
